import { render } from "./CreatePayment.vue?vue&type=template&id=6c38e3fe"
import script from "./CreatePayment.vue?vue&type=script&lang=js"
export * from "./CreatePayment.vue?vue&type=script&lang=js"

import "./CreatePayment.vue?vue&type=style&index=0&id=6c38e3fe&lang=css"

import exportComponent from "C:\\Users\\Admin\\NodeProjects\\FibreFrontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__